import { object, string, number, date, InferType } from 'yup';
import openCloseMenu from "./helpers/open-close-menu"
import showHideMenuOnScroll from "./helpers/showHideMenuOnScroll"
import initLenis from "./plugins/initLenis"
import { validations } from './validations';
import runValidation from './helpers/validationfunction';
import sauron from './helpers/observatory';

function headerJs() {
    showHideMenuOnScroll()

    // Lenis is a Smooth scroll library
    initLenis()

    openCloseMenu()


    // NEWS LETTER FORM VALIDATION
    // define the form
    // const newsletterForm = document.querySelector("#newsletter");

    // // define formfields. Always put the form and not the document as a root for queryselector
    // const formFields = {
    //     email: newsletterForm.querySelector("#email")
    // }

    // // Define a Yup schema for validation
    // const schema = object({
    //     email: validations.email
    // });

    // // define the validation object in a function so that in every sumbit that we make to the form it will get the updated value.
    // const validationObject = () => {
    //     const validationObject = { email: formFields.email.value }
    //     return validationObject;
    // }

    // function successSubmit() {
    //     console.log('Newsletter sucess')
    // }
    // function validationCallback() {
    //     runValidation(newsletterForm, formFields, validationObject, schema, successSubmit)
    // }

    // sauron(newsletterForm, newsletterForm.dataset.id, validationCallback)

}

export { headerJs }








